import { render, staticRenderFns } from "./Admin_boardMgmt_noti_Regstr.vue?vue&type=template&id=a00a6ba2&"
import script from "./Admin_boardMgmt_noti_Regstr.vue?vue&type=script&lang=js&"
export * from "./Admin_boardMgmt_noti_Regstr.vue?vue&type=script&lang=js&"
import style0 from "./Admin_boardMgmt_noti_Regstr.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports